const InformacaoNaoCadastradaConfigImg = ({ configImg }) => {
  return (
    <div className="w-full mt-10 flex justify-center">
      <img className="max-w-[60%]" alt="Informação não cadastrada" src={configImg} />
    </div>
  );
};

export default InformacaoNaoCadastradaConfigImg;
